import { Grid } from "src/components/Grid.tsx";
import { useFormContext } from "react-hook-form";
import { Flex } from "src/components/Flex.tsx";
import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { SystemSettingsFormValues } from "src/admin/administration/tabs/SystemTab/types.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { SelectField } from "src/components/Form/fields/SelectField.tsx";

export const GlobalSettings = () => {
  const { t } = useTranslation(TranslationNamespaceEnum.Administration);

  const form = useFormContext<SystemSettingsFormValues>();

  return (
    <Flex flexDirection={"column"} gap={"15px"}>
      <Grid gridTemplateColumns={"1fr"}>
        <SelectField
          showAdvancedSearch
          label={t("system.form.fields.default_country.label")}
          allowClearValue={false}
          style={{
            maxWidth: 240,
          }}
          serverOptions={{
            labelProp: "name",
            resource: ResourceEnum.Country,
          }}
          control={form.control}
          name={"default_country_id"}
        />
      </Grid>
      <Grid gridTemplateColumns={"1fr"}>
        <SelectField
          label={t("system.form.fields.default_language.label")}
          allowClearValue={false}
          style={{
            maxWidth: 240,
          }}
          serverOptions={{
            resource: ResourceEnum.Language,
          }}
          control={form.control}
          name={"default_language_id"}
        />
      </Grid>
      <Grid gridTemplateColumns={"1fr"}>
        <SelectField
          label={t("system.form.fields.default_currency.label")}
          allowClearValue={false}
          style={{
            maxWidth: 120,
          }}
          serverOptions={{
            labelProp: "iso",
            resource: ResourceEnum.Currency,
          }}
          control={form.control}
          name={"default_currency_id"}
        />
      </Grid>
    </Flex>
  );
};
